import { Component } from '@angular/core';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: [],
  standalone: false,
})
export class ButtonComponent {
  constructor() {}
}
